<template>
  <div>
  <v-data-table :headers="headers" :items="newTableList" hide-actions>
    <template slot="items" slot-scope="props">
       <tr>
          <td>
            <p>{{props.item.planName}}</p>
          </td>
          <td>
            <p>{{props.item.jobName}}</p>
          </td>
          <!-- <td>
            <p>{{props.item.unitPrice}}</p>
          </td> -->
          <td>
            <p>{{props.item.accMoney}}</p>
          </td>
          <td>
            <p>{{props.item.accDrug}}</p>
          </td>
           <td>
            <p>{{props.item.accHospital}}</p>
          </td>
          <td>
            <p>{{props.item.applicantCount}}</p>
          </td>
        </tr>
    </template>
  </v-data-table>

  </div>
</template>

<script>
import selectPlanList from '@/assets/js/planList'
import selectPlanListB from '@/assets/js/planListB'
export default {
  props: {
    code: {
      type: Number,
      default: 0
    },
    // planId: Number,
    employees: {
      type: Array,
      default() {
        return [];
      }
    },
    effectDuration: {
      type: Number,
      default: 12
    },
     allRes: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      totalObj:{
        price:0,
        count:0
      },
      newTableList:[],
      // 产品方案只有一个方案D了。原来是选择的，从 props 接受，现在只有一个了直接定义在这里
      selectPlanList:selectPlanList,
      headers: [
        {
          text: "所选计划",
          value: "planName",
          sortable: false
        },
        {
          text: "职业类别",
          value: "jobName",
          sortable: false,
        },
        // {
        //   text: "计划单价",
        //   value: "unitPrice",
        //   sortable: false,
        // },
        {
          text: "意外身故及伤残保障",
          value: "accMoney",
          sortable: false,
        },
        {
          text: "意外医药补偿",
          value: "accDrug",
          sortable: false,
        },
        {
          text: "意外每日住院津贴",
          value: "accHospital",
          sortable: false,
        },
        {
          text: "保全投保人数",
          value: "applicantCount",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
  },
  watch: {
    // 人数变了，重新计算保费
    employees:{
      handler(val){
        this.getPrice();
      },
      deep: true,
    },
    'totalObj.price'(val) {
      if(val){
        this.$emit("input", val);
      }else{
        this.$emit("input", 0);
      }
    },
  },
  created() {

  },
  mounted() {
      if (this.code == "2017"){
          this.selectPlanList = selectPlanListB
      }
    this.getPrice()
  },
  methods: {
    getPrice() {
      this.newTableList = JSON.parse(JSON.stringify(this.employees))
      this.newTableList.forEach(res=>{
        res.unitPrice = `${res.unitPrice}/${this.allRes.insurancePeriod}${this.allRes.insurancePeriodUnit == 3?'年':'月'}`
        res.planName = this.selectPlanList.find(item=>item.value.id == res.planId).name
        res.accMoney = this.selectPlanList.find(item=>item.value.id == res.planId).value.accMoney
        res.accDrug = this.selectPlanList.find(item=>item.value.id == res.planId).value.accDrug
        res.accHospital = this.selectPlanList.find(item=>item.value.id == res.planId).value.accHospital
      })
      this.totalObj.price = this.allRes.amounts
    },
  }
};
</script>

<style lang="scss">
.c-insurance-plan {
  width: 745px;
  .thead-th {
    width: 195px;
    .thead-input {
      width: 3em;
      display: inline-block;
    }
  }
  // 框架样式覆盖
  .v-text-field.v-text-field--solo .v-input__control {
    flex: none;
    width: 120px;
    min-height: 30px;
  }
  .v-select {
    justify-content: center;
    font-size: inherit;
  }
}
.price{
  margin-left: 20px;
}
.price-footer{
  margin-top: 30px;
  justify-content: right;
}
</style>


